import {
    UpdateIcon
} from '@radix-ui/react-icons';
import { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent, DialogHeader,
    DialogTitle,
    DialogTrigger
} from "../ui/dialog";
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from '../ui/use-toast';

import api from '../../lib/api';
import { DropdownMenuItem } from '../ui/dropdown-menu';

function AddRegistrationCommentDialog({ currentComment, onSave, useApi = false, registrationId, dropdown }) {
    const [comment, setComment] = useState(currentComment || "");
    const [isLoading, setIsLoading] = useState(false);

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    };

    const handleSave = async () => {
        if (isLoading) return;

        setIsLoading(true);

        const trimmedComment = comment.trim();

        if (useApi && registrationId) {

            try {
                await api.post(`https://skhrf-api.cmdigital.se/v1/registrations/add-comment`, {
                    registrationId,
                    comment: trimmedComment,
                });

                toast({
                    title: 'Kommentar tillagd',
                });
            } catch (error) {
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: error.response?.data?.error || 'Ett oväntat fel inträffade.',
                });
            } finally {
                setIsLoading(false);
            }
        } else {
            // Use the provided onSave callback if no API call is needed
            onSave(trimmedComment);
            setIsLoading(false);
            setIsDialogOpen(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            {dropdown ? (
                <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                    <DialogTrigger className='flex items-center text-start w-full'>
                        {currentComment ? `Redigera kommentar` : `Lägg till kommentar`}
                    </DialogTrigger>
                </DropdownMenuItem>
            ) : (
                <DialogTrigger className='flex items-center w-full' asChild>
                    <Button>
                        Redigera kommentar
                    </Button>
                </DialogTrigger>
            )}
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className="text-left">
                    <DialogTitle>Lägg till kommentar</DialogTitle>
                </DialogHeader>
                <div className="flex flex-col gap-2 w-full">
                    <Label htmlFor="comment">Kommentar (max 70 tecken):</Label>
                    <Input
                        placeholder="Skriv en kommentar"
                        id='comment'
                        name="comment"
                        maxLength="70"
                        value={comment}
                        onChange={handleCommentChange}
                        disabled={isLoading}
                    />
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <DialogClose asChild>
                        <Button type="button" variant="secondary">
                            Avbryt
                        </Button>
                    </DialogClose>
                    <Button type="button" onClick={handleSave} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className="loader-spinner" /> : <>Spara</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}


export default AddRegistrationCommentDialog;
